import { render, staticRenderFns } from "./GuppyAudioMessage.vue?vue&type=template&id=2f2d8474&scoped=true&"
import script from "./GuppyAudioMessage.vue?vue&type=script&lang=js&"
export * from "./GuppyAudioMessage.vue?vue&type=script&lang=js&"
import style0 from "./GuppyAudioMessage.vue?vue&type=style&index=0&id=2f2d8474&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2f2d8474",
  null
  
)

export default component.exports